// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import OrderClient from '@/api/order/order-client';
const orderClient = new OrderClient();
export default {
    createOrder: async function (context, payload) {
        var result = await orderClient.postAsync({
            url: `${orderClient.url}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    updateOrder: async function (context, payload) {
        var result = await orderClient.putAsync({
            url: `${orderClient.url}/${payload.id}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    deleteOrder: async function (context, payload) {
        var result = await orderClient.deleteAsync({
            url: `${orderClient.url}/${payload.id}`,
        }, true);
        return result;
    },


    getOrder: async function (context, payload) {
        var result = await orderClient.getAsync({
            url: `${orderClient.url}/${payload.id}/detail`
        }, true);
        if (result && result.data) {
            return result.data;
        }
        return null;
    },

    getOrders: async function (context, payload) {
        var result = await orderClient.getAsync({
            url: `${orderClient.url}/search`,
            queries: payload
        }, true);
        if (result && result.data) {
            context.commit('updateTotalPage', result.data);
            return result.data;
        }
        return null;
    },


    createOrderItem: async function (context, payload) {
        var result = await orderClient.postAsync({
            url: `${orderClient.url}/add-items`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    getOrderItem: async function (context, payload) {
        var result = await orderClient.getAsync({
            url: `${orderClient.url}/order-items/${payload.id}/detail`,
            data: payload
        }, true);
        if (result && result.data) {
            return result.data;
        }
        return null;
    },
}